// services/ClientEOIService.js
import apiInstance from '../utils/axiosConfig';

const ClientEOIService = {
    // Créer un ClientEOI avec fichiers
    createClientEOI: async (clientEOIRequestDTO, mediaFiles = []) => {
        try {
            const formData = new FormData();

            // Ajouter les données JSON
            formData.append('eoiData', JSON.stringify(clientEOIRequestDTO));

            // Ajouter les fichiers
            if (mediaFiles && mediaFiles.length > 0) {
                mediaFiles.forEach(file => {
                    formData.append('mediaFiles', file);
                });
            }

            // ✅ Pas de header Content-Type manuel : l'intercepteur axios
            // (axiosConfig.js) le retire automatiquement pour les FormData,
            // ce qui laisse le navigateur générer le bon boundary.
            const response = await apiInstance.post('/client-eois/createClientEOI', formData);
            return response.data;
        } catch (error) {
            console.error('Error creating ClientEOI:', error.message || error);
            throw error;
        }
    },

    // Récupérer un ClientEOI par ID
    getClientEOIById: async (id) => {
        try {
            const response = await apiInstance.get(`/client-eois/getClientEOIById/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching ClientEOI by id:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les ClientEOIs
    getAllClientEOIs: async () => {
        try {
            const response = await apiInstance.get('/client-eois/getAllClientEOIs');
            return response.data;
        } catch (error) {
            console.error('Error fetching all ClientEOIs:', error.message || error);
            throw error;
        }
    },

    // Récupérer les ClientEOIs par client ID
    getClientEOIsByClientId: async (clientId) => {
        try {
            const response = await apiInstance.get(`/client-eois/client/${clientId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching ClientEOIs by client id:', error.message || error);
            throw error;
        }
    },

    // Récupérer les ClientEOIs par professional ID
    getClientEOIsByProfessionalId: async (professionalId) => {
        try {
            const response = await apiInstance.get(`/client-eois/professional/${professionalId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching ClientEOIs by professional id:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un ClientEOI avec fichiers (multipart)
    updateClientEOI: async (id, clientEOIRequestDTO, mediaFiles = []) => {
        try {
            const formData = new FormData();

            // Ajouter les données JSON
            formData.append('eoiData', JSON.stringify(clientEOIRequestDTO));

            // Ajouter les fichiers (optionnel)
            if (mediaFiles && mediaFiles.length > 0) {
                mediaFiles.forEach(file => {
                    formData.append('mediaFiles', file);
                });
            }

            // ✅ Pas de header Content-Type manuel ici non plus
            const response = await apiInstance.put(`/client-eois/updateClientEOI/${id}`, formData);
            return response.data;
        } catch (error) {
            console.error('Error updating ClientEOI:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un ClientEOI sans fichiers (JSON pur)
    // Utilisé par exemple pour l'annulation, où aucun fichier n'est nécessaire
    updateClientEOIJson: async (id, clientEOIRequestDTO) => {
        try {
            const response = await apiInstance.put(`/client-eois/updateClientEOI/${id}`, clientEOIRequestDTO, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error updating ClientEOI (JSON):', error.message || error);
            throw error;
        }
    },

    // Mettre à jour le Professional ID d'un ClientEOI
    updateProfessionalId: async (id, newProfessionalId, lastModifiedBy) => {
        try {
            const response = await apiInstance.get(
                `/client-eois/updateProfessionalId/${id}/${newProfessionalId}`,
                {
                    params: { lastModifiedBy }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error updating professional ID:', error.message || error);
            throw error;
        }
    },

    // Supprimer un ClientEOI
    deleteClientEOI: async (id) => {
        try {
            await apiInstance.delete(`/client-eois/deleteClientEOI/${id}`);
        } catch (error) {
            console.error('Error deleting ClientEOI:', error.message || error);
            throw error;
        }
    },
};

export default ClientEOIService;